import { LocaleUtils } from "@grandvisionhq/utils";
import { getToken } from "./token-service.js";
const getCustomerUri = (apiUrl, customerId) => `${apiUrl}/customers/customer/${encodeURIComponent(customerId)}`;
const getAccountUri = (apiUrl) => `${apiUrl}/customers/account`;
const unwrapResponse = async (response) => {
  if (!response.ok) {
    let result = "";
    try {
      result = await response.text();
    } catch {
    }
    throw new Error(
      `Got non OK response from server: ${response.status} ${response.statusText}: ${result}`
    );
  }
  return response.json();
};
const baseOptions = {
  mode: "cors",
  credentials: "omit",
  cache: "no-cache"
};
const optIns = {
  /**
   * @deprecated use the new GQL hook
   * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
   */
  async fetch(apiUrl, customerId) {
    const accessToken = await getToken();
    return unwrapResponse(
      await fetch(`${getCustomerUri(apiUrl, customerId)}/optins`, {
        ...baseOptions,
        method: "GET",
        headers: new Headers({
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        })
      })
    );
  },
  /**
   * @deprecated use the new GQL hook
   * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
   */
  async update(apiUrl, customerId, optinUpdates) {
    const accessToken = await getToken();
    return unwrapResponse(
      await fetch(`${getCustomerUri(apiUrl, customerId)}/optins`, {
        ...baseOptions,
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify({
          optinUpdates
        })
      })
    );
  }
};
const account = {
  async signup(apiUrl, loginRedirectUrl, emailAddress, additionalAccountData, reason) {
    const { personalDetails = {}, optins = {} } = additionalAccountData;
    const optInsUpdate = Object.keys(optins).length > 0 ? optins : void 0;
    const additionalData = { personalDetails, optins: optInsUpdate };
    const locale = LocaleUtils.getLocaleFromCookie();
    const stateParams = { targetAction: "signUp" };
    let body = {
      loginRedirectUrl,
      emailAddress,
      state: JSON.stringify(stateParams),
      reason,
      ...additionalData
    };
    body = locale ? { ...body, locale } : body;
    return unwrapResponse(
      await fetch(`${getAccountUri(apiUrl)}/create`, {
        ...baseOptions,
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Accept: "application/json"
        }),
        body: JSON.stringify(body)
      })
    );
  },
  async activate(apiUrl, accessToken, accountId, emailAddress, password, consents2) {
    const locale = LocaleUtils.getLocaleFromCookie();
    let body = {
      emailAddress,
      password,
      consents: consents2
    };
    body = locale ? { ...body, locale } : body;
    return unwrapResponse(
      await fetch(`${getAccountUri(apiUrl)}/activate/${encodeURIComponent(accountId)}`, {
        ...baseOptions,
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(body)
      })
    );
  },
  async changePassword(apiUrl, accessToken, accountId, password) {
    return unwrapResponse(
      await fetch(`${getAccountUri(apiUrl)}/changepassword/${encodeURIComponent(accountId)}`, {
        ...baseOptions,
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify({ password })
      })
    );
  }
};
export {
  account,
  optIns
};
//# sourceMappingURL=customer-service.js.map
